module.exports = __webpack_public_path__ + "static/media/hiper.813249f9.svg";